<div id="videoPlayer" class="video-player tiktok-player" *ngIf="isTikTokVideo() && urlSafe">
    <div class="tiktok-player-layout">
        <div class="tiktok-phone-frame">
            <iframe
                class="tiktok-embed-video"
                [src]="urlSafe"
                allow="autoplay"
                allowfullscreen
                title="TikTok video"
            ></iframe>
        </div>
        <div class="tiktok-video-overlay" aria-hidden="true"></div>
        <div class="tiktok-player-copy">
            <div class="eyebrow">See how it works</div>
            <div class="headline">With TikTok ads</div>
        </div>
    </div>
</div>
<div id="videoPlayer" class="video-player" *ngIf="!isTikTokVideo() && urlSafe" [style.height.px]="getHeight()">
    <div class="aligns">
        <iframe style="border: none"
        height="100%"
        width="100%"
        [src]="urlSafe"
        allow="autoplay=true;"
        allowfullscreen
        style="border:none"  
        title="">
         </iframe>
    </div>
</div>  
